import libraries from './content/sagas'
import libraryElements from './content/items/sagas'
import contentItem from './content/items/details/sagas'

export default [libraries, libraryElements, contentItem]
